/**
 * 編譯期設定。
 *
 * C03 §5 硬性規定：任何 redirect_uri / 分享連結一律用**編譯期注入的 PUBLIC_BASE_URL**
 * 組出來，**絕不**從 `window.location.host` 組。理由：兄弟子網域（rps. / admin.rps. /
 * admin.）若能互相冒用 host 來組 redirect，就等於打通了跨角色的 session 邊界。
 */

export type Locale = 'zh-TW' | 'en';

export interface AppConfig {
  apiBaseUrl: string;
  wsUrl: string;
  publicBaseUrl: string;
  basePath: string;
  gameKey: string;
  useMocks: boolean;
  defaultLocale: Locale;
  buildVersion: string;
  /** sessionStorage key 前綴。C03 §5：每個站點各自獨立的儲存前綴。 */
  storagePrefix: string;
}

function env(key: string, fallback: string): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  return raw === undefined || raw === '' ? fallback : raw;
}

export const config: AppConfig = {
  apiBaseUrl: env('VITE_API_BASE_URL', 'https://api.gaming.enlightenmentlab.dev/api/v1'),
  wsUrl: env('VITE_WS_URL', 'wss://api.gaming.enlightenmentlab.dev/api/v1/ws'),
  publicBaseUrl: env('VITE_PUBLIC_BASE_URL', 'https://rps.gaming.enlightenmentlab.dev').replace(/\/+$/, ''),
  basePath: env('VITE_PUBLIC_BASE_PATH', '/'),
  gameKey: env('VITE_GAME_KEY', 'rps'),
  useMocks: env('VITE_USE_MOCKS', '0') === '1',
  defaultLocale: env('VITE_DEFAULT_LOCALE', 'zh-TW') === 'en' ? 'en' : 'zh-TW',
  buildVersion: env('VITE_BUILD_VERSION', 'dev'),
  storagePrefix: 'elabgaming.rps.',
};

/**
 * 分享連結一律由編譯期的 publicBaseUrl 組成（C03 §5）。
 * `path` 必須是以單一 `/` 開頭的絕對路徑。
 */
export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const base = config.basePath === '/' ? '' : config.basePath.replace(/\/+$/, '');
  return `${config.publicBaseUrl}${base}${normalized}`;
}
